export const getRootDomain = () =>
  PF.config.ms_teams_domain || PF.config.development_domain || window.location.hostname;
